import { DeleteFilled } from "@ant-design/icons";
import React from "react";
import styled from "styled-components";
import { COLORS } from "../../constants/colors";


interface Props {
    active: boolean;
    icon?: React.ReactNode;
    method?: () => void;
    color: string;
    props?: any;
    background?: string;
    width?: string;
    height?: string;
    sizeIcon?: string;
}

const ButtonGrapper = styled.div<Props>`
    background-color: ${props => !!props.background ? props.background : COLORS.transparent_color1};
    border-radius: 5px;
    overflow: hidden;
    border: 1px solid ${props => props.color};
    /* width: fit-content; */
    width: ${props => props.width};
    transition: all 0.07s;
    height: ${props => props.height};
    opacity: ${props => props.active ? 1 : 0.5};
    
    .icon {
        font-size: ${props => props.sizeIcon};
        width: 100%;
        height: 100%;
        color: ${props => props.color};
        display: flex;
        justify-content: center;
        align-items: center;
        transition: all 0.07s;
    }

    
    ${props => props.active && (`
        cursor: pointer;
        
        :active {
            opacity: 0.7;
        }

        :hover {
            box-shadow: 1px 1.5px 3px 0px ${COLORS.black_text_color3}
        }

        .icon:hover {
            transform: scale(1.1);
        }
    `)}
    

`;

const ButtonGrid = ({ active, method, icon, color, props, background, width = '40px', height = '40px', sizeIcon = '1.5em' }: Props): JSX.Element => {

    return (
        <ButtonGrapper {...props} width={width} height={height} sizeIcon={sizeIcon} active={active} color={color} background={background} onClick={!!active ? method : null}>
            <nav className="icon">{icon}</nav>
        </ButtonGrapper>
    )
}


export default ButtonGrid;